<template>
	<div>
		<core-monaco-editor
			style="height: 100vh"
			language="json"
			v-model="displayedData"
			:readOnly="true"
		/>
	</div>
</template>

<script>
import CoreMonacoEditor from "@/modules/core/components/CoreMonacoEditor"

export default {
	components: { CoreMonacoEditor },

	data() {
		return {}
	},

	computed: {
		displayedData() {
			const caseData = this.$store.state.caseManagement.case
			const proposalsData = this.$store.state.caseManagement.proposals
			const combinedCase = { ...caseData, proposals: proposalsData }
			let stringifiedOutput

			try {
				stringifiedOutput = JSON.stringify(combinedCase, null, 2)
			} catch (e) {
				console.error(e)
			}

			return stringifiedOutput
		}
	}
}
</script>
